import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSingleNeutralActionsUpDown = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "single-neutral-actions-up-down" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 7.5,
			cy: 4.875,
			r: 4.125
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M.75,17.25a6.75,6.75,0,0,1,11.243-5.037"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "cls-1",
			points: "11.25 20.25 14.25 23.25 17.25 20.25"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 14.25,
			y1: 23.25,
			x2: 14.25,
			y2: 14.25
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "cls-1",
			points: "17.25 17.25 20.25 14.25 23.25 17.25"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 20.25,
			y1: 14.25,
			x2: 20.25,
			y2: 23.25
		})
	]
});
export default SvgSingleNeutralActionsUpDown;
